import { render, staticRenderFns } from "./systermAuthorOne.vue?vue&type=template&id=31485cd0&scoped=true&"
import script from "./systermAuthorOne.vue?vue&type=script&lang=js&"
export * from "./systermAuthorOne.vue?vue&type=script&lang=js&"
import style0 from "./systermAuthorOne.vue?vue&type=style&index=0&id=31485cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31485cd0",
  null
  
)

export default component.exports